/**
 * Order Validation Utilities
 * Validiert Bestellungen gegen alle konfigurierten Regeln
 */

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Vollständige Bestellvalidierung
 * @param {Object} orderData - Bestelldaten
 * @param {string} orderData.order_type - "pickup", "delivery", "dine_in"
 * @param {string} orderData.postal_code - PLZ für Lieferung
 * @param {number} orderData.total_value - Gesamtwert
 * @param {Array} orderData.items - [{product_id, quantity}]
 * @returns {Promise<Object>} - {valid, errors, warnings, delivery_fee}
 */
export async function validateOrder(orderData) {
  try {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE}/api/order-rules/validate-order`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(orderData)
    });

    if (response.ok) {
      return await response.json();
    } else {
      const error = await response.json();
      return {
        valid: false,
        errors: [error.detail || 'Validierung fehlgeschlagen'],
        warnings: []
      };
    }
  } catch (error) {
    return {
      valid: false,
      errors: ['Netzwerkfehler bei Validierung'],
      warnings: []
    };
  }
}

/**
 * Prüft ob Lieferung verfügbar ist
 * @param {string} postalCode - PLZ
 * @param {number} totalValue - Bestellwert
 * @returns {Promise<Object>} - Zone-Info oder Fehler
 */
export async function checkDeliveryAvailability(postalCode, totalValue) {
  try {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE}/api/order-rules/delivery-zones/check`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        postal_code: postalCode,
        total_value: totalValue
      })
    });

    if (response.ok) {
      return await response.json();
    } else {
      const error = await response.json();
      throw new Error(error.detail);
    }
  } catch (error) {
    throw error;
  }
}

/**
 * Lädt Bestelltyp-Regeln
 * @returns {Promise<Array>}
 */
export async function getOrderTypeRules() {
  try {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE}/api/order-rules/order-types`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (response.ok) {
      const data = await response.json();
      return data.rules || [];
    }
    return [];
  } catch (error) {
    return [];
  }
}

/**
 * Produkt temporär deaktivieren (86'd)
 * @param {string} productId 
 * @param {boolean} disabled 
 * @param {string} reason 
 */
export async function quickDisableProduct(productId, disabled, reason = '') {
  try {
    const token = localStorage.getItem('access_token');
    const response = await fetch(`${API_BASE}/api/order-rules/products/${productId}/quick-disable`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        disabled: disabled,
        reason: reason
      })
    });

    return response.ok;
  } catch (error) {
    return false;
  }
}
